import {Duration} from '../../../Domain/Duration';
import {round} from './Internal/round';

export function formatRecoverTime(recoverTime: Duration | null): {formatted: string; unit?: string} {
    if (recoverTime === null) {
        return {formatted: 'N/A'};
    }

    return {formatted: round(recoverTime.seconds, 2), unit: 's'};
}

export function formatAverageRecoverTime(recoverTime: Duration | null): {formatted: string; unit?: string} {
    if (recoverTime === null) {
        return {formatted: 'N/A'};
    }

    return {formatted: round(recoverTime.seconds, 2), unit: 's'};
}
